import request from '@/utils/request'


// 查询设备阴极保护评价信息列表
export function listDeviceEvaluate(query) {
  return request({
    url: '/saifuneng/saifuneng-device-evaluate/list',
    method: 'get',
    params: query
  })
}

// 查询设备阴极保护评价信息分页
export function pageDeviceEvaluate(query) {
  return request({
    url: '/saifuneng/saifuneng-device-evaluate/page',
    method: 'get',
    params: query
  })
}

// 查询设备阴极保护评价信息详细
export function getDeviceEvaluate(data) {
  return request({
    url: '/saifuneng/saifuneng-device-evaluate/detail',
    method: 'get',
    params: data
  })
}

// 新增设备阴极保护评价信息
export function addDeviceEvaluate(data) {
  return request({
    url: '/saifuneng/saifuneng-device-evaluate/add',
    method: 'post',
    data: data
  })
}

// 修改设备阴极保护评价信息
export function updateDeviceEvaluate(data) {
  return request({
    url: '/saifuneng/saifuneng-device-evaluate/edit',
    method: 'post',
    data: data
  })
}

// 删除设备阴极保护评价信息
export function delDeviceEvaluate(data) {
  return request({
    url: '/saifuneng/saifuneng-device-evaluate/delete',
    method: 'post',
    data: data
  })
}

// 查询管线信息列表
export function listPipeline(query) {
  return request({
    url: '/saifuneng/saifuneng-pipeline/list',
    method: 'get',
    params: query
  })
}

// 查询设备类型信息列表
export function listDeviceType(query) {
  return request({
    url: '/saifuneng/saifuneng-device-type/list',
    method: 'get',
    params: query
  })
}